import type { ReactNode } from 'react';
import { createPortal } from 'react-dom';

interface ConsentDialogProps {
  icon: ReactNode;
  iconClassName?: string;
  title: string;
  subtitle?: string;
  children: ReactNode;
  footer: ReactNode;
}

/**
 * Huelle fuer die Dialoge des Gates.
 *
 * Bewusst ohne Schliessen-Kreuz und ohne Klick auf den Hintergrund: das
 * Gate ist kein Hinweis, den man wegwischt. Wer nicht zustimmen will,
 * nimmt den Ablehnen-Weg - der ist ein eigener, bestaetigter Vorgang.
 *
 * Die bottom-sheet-Klassen kommen aus styles/index.css und sind dieselben,
 * die alle uebrigen Modals der App verwenden (z-index 9998/9999, also ueber
 * TopBar und BottomNav).
 */
export function ConsentDialog({
  icon,
  iconClassName = 'bg-blue-500/20',
  title,
  subtitle,
  children,
  footer,
}: ConsentDialogProps) {
  return createPortal(
    <>
      <div className="bottom-sheet-backdrop" />
      <div className="bottom-sheet-container">
        <div className="bottom-sheet-modal max-w-lg" role="dialog" aria-modal="true">
          <div className="bottom-sheet-header">
            <div className="flex items-center gap-3">
              <div
                className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 ${iconClassName}`}
              >
                {icon}
              </div>
              <div>
                <h2>{title}</h2>
                {subtitle && <p className="text-white/50 text-xs mt-0.5">{subtitle}</p>}
              </div>
            </div>
          </div>

          <div className="bottom-sheet-content">{children}</div>

          <div className="bottom-sheet-footer flex-col gap-2">{footer}</div>
        </div>
      </div>
    </>,
    document.body
  );
}
